import styled from 'styled-components'
import { device } from '../responsive'
// import { Link as LinkR } from 'react-router-dom'
import { Link as LinkS } from 'react-scroll'

export const Nav = styled.nav`
    -webkit-box-shadow: 0px 5px 7px -8px rgba(0,0,0,0.18); 
    box-shadow: 0px 5px 7px -8px rgba(0,0,0,0.18);
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    right: 0;
    background-color: white;
    height: 80px;
    z-index: 5;
`
export const NavContainer = styled.div`
    max-width: 1250px;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0rem 2rem;
    height: 80px;
`
export const NavLogo = styled(LinkS)`
    
`
export const Image = styled.img`
    width: 40px;
    cursor: pointer;

    @media screen and ${device.mobile} {
        width: 38px;
    }
`
export const NavMenu = styled.ul`
    width: 400px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    list-style: none;

    @media screen and ${device.tablet} {
        display: none;
    }
`
export const NavItem = styled.li`
    height: 80px; 
`

export const NavLink = styled(LinkS)`
    text-decoration: none;
    font-size: 13px;
    letter-spacing: 1px;
    cursor: pointer;
    color: #2F2E41;
    height: 100%;
    align-items: center;
    display: flex;
    font-weight: 500;
    &:active {
        color: teal;
        
        border-bottom: 3px solid teal;
    }
    &:hover {
        color: teal;
        
        border-bottom: 3px solid teal;
    }
`

export const MenuIcon = styled.div`
    display: none;

    @media screen and ${device.tablet} {
        display: block;
        cursor: pointer;
    }
`
